// extracted by mini-css-extract-plugin
export default {"login":"login_login__S4+5n","img":"login_img__N0-FY","login_page":"login_login_page__VanJN"};